import {
  ConsumptionEnergyType,
  EnergySystemType,
  HourSeriesType,
} from '../generated/graphql'

export type HourSeriesResult = {
  hourSerieType: HourSeriesType
  energySystemType: EnergySystemType
  consumptionEnergyType: ConsumptionEnergyType
  hourSerieName: string
  hourSerie: number[]
}

export enum InputHourSerieType {
  VentilationElectricityDemand,
  VentilationCoolingDemand,
  VentilationHeatingDemand,
  HeatLoadAppliancesElectricityDemand,
  HeatLoadLightingElectricityDemand,
  HeatLoadHeatloadSupply,
}

export type HourSerieCalculatorResult = {
  outputs: HourSeriesResult[]
  inputs: InputHourSerieResult[]
}

export type InputHourSerieResult = {
  sourceSystemType: EnergySystemType
  targetSystemType: EnergySystemType
  inputSerieType: InputHourSerieType
  hourSerie: number[]
}
